import { useHistory, useLocation } from "react-router-dom";
import { useDeleteInvoice } from "@/hooks/invoice/use-delete-invoice";
import { toast } from "react-toastify";
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button-tw";
import { cn } from "@/utils/classnames";

export default function DeleteInvoiceAlert() {
  const history = useHistory();
  const location = useLocation();
  const { mutate: deleteInvoice, isLoading: deleting } = useDeleteInvoice();
  const queryParams = new URLSearchParams(location.search);

  const dialogOpen = queryParams.has("delete_invoice");
  const invoiceId = queryParams.get("delete_invoice");

  const closeDialog = () => {
    if (queryParams.has("delete_invoice")) {
      queryParams.delete("delete_invoice");
      history.replace({
        search: queryParams.toString(),
      });
    }
  };

  return (
    <AlertDialog open={dialogOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Double checking...</AlertDialogTitle>
          <AlertDialogDescription>
            <span
              className={cn(
                "text-sm text-muted-foreground text-center sm:text-left"
              )}
            >
              Are you sure you'd like to delete this invoice?
            </span>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel
            disabled={deleting}
            onClick={() => {
              closeDialog();
            }}
          >
            Cancel
          </AlertDialogCancel>
          <Button
            variant="destructive"
            onClick={() => {
              deleteInvoice(invoiceId, {
                onSuccess: () => {
                  toast.success("Your invoice has been deleted.");
                  closeDialog();
                },
              });
            }}
            disabled={deleting}
          >
            Delete
            {deleting && <Loader2 className="w-4 h-4 ml-2 animate-spin" />}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
